/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/ToDays.ts
 * @create:      2025-06-27 10:43:28.155
 * @modify:      2025-07-11 21:19:12.817
 * @version:     6.0.0
 * @times:       20
 * @lines:       50
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { MillisecondsPerDay } from "../const/TimeFactor";
import { TTimeUnit } from "../type/advanced";
import { ToMilliseconds } from "./ToMilliseconds";

/**
 * Converts a numeric time value from a specified unit to the equivalent number of days.
 *
 * @param num - The numeric value representing the amount of time.
 * @param currentUnit - The unit of the input time value (e.g., seconds, minutes, hours).
 * @returns The equivalent time in days.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function ToDays(num: number, currentUnit: TTimeUnit) {
    return ToMilliseconds(num, currentUnit) / MillisecondsPerDay;
}
